import { createConnectQueryKey, useMutation } from '@connectrpc/connect-query'
import { useQueryClient } from '@tanstack/react-query'

import { toaster } from '@enechain/ecloud-designsystem'

import { resetMultifactorAuthentication } from '~/gen/proto/bff/v1/admin-BffAdminService_connectquery'
import { BffAdminService } from '~/gen/proto/bff/v1/admin_pb'

export function useResetMfa(
  memberId: string,
  onSuccess: () => void,
): ReturnType<typeof useMutation> {
  const queryClient = useQueryClient()

  return useMutation(resetMultifactorAuthentication, {
    onError: (error) => {
      toaster.create({
        title: error.message,
        type: 'error',
      })
    },
    onSuccess: () => {
      void queryClient.refetchQueries({
        queryKey: createConnectQueryKey({
          schema: BffAdminService.method.getMember,
          input: { memberId: memberId },
          cardinality: 'finite',
        }),
      })

      onSuccess()
    },
  })
}
